<template>
  <v-dialog
    v-model="dialog"
    width="450"
    scrollable
  >
    <v-card
      min-height="450"
      :loading="loading"
    >
      <template slot="progress">
        <v-overlay absolute class="d-flex flex-column text-center">
          <v-progress-circular size="75" coleor="accent" indeterminate>
            <span>Loading</span>
          </v-progress-circular>
        </v-overlay>
      </template>
      <template
        v-if="!loading"
      >
        <v-card-title>
          Titulo
        </v-card-title>
        <v-card-subtitle>
          Subtitulo
        </v-card-subtitle>

        <v-divider class="mx-4"></v-divider>

        <v-card-text>
          <v-text-field>
            {{ resumenLLM }}
          </v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="runLLMQuery">Analizar</v-btn>
          <v-btn
            outlined
            color="grey"
            @click="dialog = !dialog"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    personId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      loading: false,
      userQuery: null,
      resumenLLM: '',
    };
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    async runLLMQuery() {
      const response = await fetch('http://127.0.0.1:8000/api/v1/jim-morrinson-logs/access-logs/stream?user_message=Analiza estos datos, dime quienes tienen entrada y no salida y viceversa', {
        method: 'GET',
      });
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      // eslint-disable-next-line no-constant-condition
      while (true) {
        // eslint-disable-next-line no-await-in-loop
        const { done, value } = await reader.read();
        if (done) {
          break;
        }
        // this.resumenLLM += decoder.decode(value);
        this.resumenLLM += decoder.decode(value, { stream: true });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/LogAnalysisModal.vue